import ArrowDownIcon from "@untitled-ui/icons-react/build/esm/ArrowDown";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Unstable_Grid2";
import Stack from "@mui/material/Stack";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

import { RouterLink } from "src/components/router-link";
import { Seo } from "src/components/seo";
import { usePageView } from "src/hooks/use-page-view";
import { paths } from "src/paths";
import type { PaletteMode } from "src/theme";
import { privacyPolicy } from "./privacypolicy";

import Markdown from "react-markdown";
import { PluggableList } from "react-markdown/lib";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { markdownComponents } from "../dashboard/helpers/markdownlhelpers";

interface Item {
  image: string;
  newTab?: boolean;
  path: string;
  subtitle: string;
  title: string;
}

interface Section {
  title: string;
  items: Item[];
}

const LegalNoticePage = () => {
  const theme = useTheme();

  usePageView();

  return (
    <>
      <Seo title="Components" />
      <Box
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === "dark" ? "neutral.800" : "neutral.50",
          py: "120px",
        }}
      >
        <Container maxWidth="md">
          <Stack spacing={1}>
            <Typography color="text.primary" variant="body1">
              <Markdown
                children={privacyPolicy}
                components={markdownComponents}
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw] as PluggableList}
              />
            </Typography>
          </Stack>
        </Container>
      </Box>
    </>
  );
};

export default LegalNoticePage;
